export default __webpack_public_path__ + "static/media/ic_tether_24.a7c88dcd.svg";